import { render, staticRenderFns } from "./PasswordInstructions.vue?vue&type=template&id=5b803877"
import script from "./PasswordInstructions.vue?vue&type=script&lang=js"
export * from "./PasswordInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports